<template>
    <MainContainer>
        <div class="buchung-zuschusskonto">
            <FiBuBuchungGruppierungskonten
                :id="id"
            ></FiBuBuchungGruppierungskonten>
        </div>
    </MainContainer>
</template>

<script>
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import FiBuBuchungGruppierungskonten from "@/components/FiBuBuchungGruppierungskonten/FiBuBuchungGruppierungskonten";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "FiBu_Buchung_Gruppierungskonten",
    mixins: [Size, Currency, Validation],
    components: {
        MainContainer,
        FiBuBuchungGruppierungskonten
    },
    data() {
        return {};
    },
    computed: {
        id() {
            return this.$route.params.id;
        }
    },
    async created() {},
    watch: {},
    methods: {}
};
</script>
